import { Route, Routes } from "react-router-dom";
import HistorialLeccionesHome from "../../../components/Herramientas/historial-lecciones/HistorialLeccionesHome";
import React from "react";

const HistorialLeccionesRoutes = () => {
  return (
    <Routes>
      <Route index element={<HistorialLeccionesHome />} />
    </Routes>
  );
};

export default HistorialLeccionesRoutes;
